import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { RadioButton, TextAreaInput, TextInput } from '../../../UI'
import ReactBootstrapSlider from 'react-bootstrap-slider'

class AddInfo extends Component {
  static defaultProps = {
    budget: [250, 2000],
    requestedBudgetMin: 250,
    requestedBudgetMax: 2000,
    tripTempo: 'Relaxed',
    tripBudgetTypeValue: 'Per Person',
    tripBudgetType: 'PerPerson',
    comments: ''
  }

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    this.state = {
      budget: this.props.currentState.budget || this.props.budget,
      tripTempo: this.props.currentState.tripTempo || this.props.tripTempo,
      tripBudgetType: this.props.currentState.tripBudgetType || this.props.tripBudgetType,
      tripBudgetTypeValue: this.props.currentState.tripBudgetTypeValue || this.props.tripBudgetTypeValue,
      requestedBudgetMin: this.props.currentState.requestedBudgetMin || this.props.requestedBudgetMin || 45,
      requestedBudgetMax: this.props.currentState.requestedBudgetMax || this.props.requestedBudgetMax || 20000,
      comments: this.props.currentState.comments || this.props.comments
    }
  }

  componentDidMount() {
    this.props.updateState(this.state)
  }

  componentWillReceiveProps(nextProps) {
    this.setState(Object.assign(this.state, nextProps.currentState))
  }

  onChange = event => {
    let name = event.target.name
    this.setState(
      {
        [name]: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  onChangeComments = () => {
    this.setState(
      {
        comments: document.getElementById('comments').value
      },
      () => this.props.updateState(this.state)
    )
  }

  onTypeChoice = event => {
    this.setState(
      {
        tripBudgetType: event.target.id,
        tripBudgetTypeValue: event.target.value
      },
      () => this.props.updateState(this.state)
    )
  }

  getRange = event => {
    let requestedBudgetMin, requestedBudgetMax
    ;[requestedBudgetMin, requestedBudgetMax] = event.target.value
    this.setState(
      {
        budget: event.target.value,
        requestedBudgetMin: requestedBudgetMin,
        requestedBudgetMax: requestedBudgetMax
      },
      () => this.props.updateState(this.state)
    )
  }

  componentWillUnmount() {
    delete this.state.budget
    this.props.updateState(this.state)
  }

  render() {
    const { t } = this.props

    return (
      <div className="add-info">
        <h2 className="section-title">{t('describe_trip')}</h2>

        <div className="add-info__tempo">
          <div className="form-group">
            <h3 className="sub-header">{t('trip_tempo')}</h3>
            <select value={this.state.tripTempo} name="tripTempo" className="form-control group__group-select" onChange={this.onChange}>
              <option value="Relaxed">{t('relaxed')}</option>
              <option value="Moderate">{t('moderate')}</option>
              <option value="Fast">{t('fast')}</option>
            </select>
          </div>
          <div className="form-group budget-slider">
            <h3 className="sub-header">{t('total_budget')}</h3>

            <div style={{ marginBottom: 25 }}>
              <label className="budgetLabel" htmlFor="min-budget">
                Min Budget
              </label>
              <input
                className="budgetInput"
                id="minBudget"
                name="minBudget"
                value={this.state.requestedBudgetMin}
                onChange={e => this.setState({ requestedBudgetMin: e.target.value }, () => this.props.updateState(this.state))}
              />
            </div>

            <div style={{ marginBottom: 25 }}>
              <label className="budgetLabel" htmlFor="max-budget">
                Max Budget
              </label>
              <input
                className="budgetInput"
                id="maxBudget"
                name="maxBudget"
                value={this.state.requestedBudgetMax}
                onChange={e => this.setState({ requestedBudgetMax: e.target.value }, () => this.props.updateState(this.state))}
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-group form-horizontal payments__radiogroup">
              <div>
                <RadioButton
                  name="tripBudgetType"
                  value={t('per_person')}
                  checked={this.state.tripBudgetTypeValue === t('per_person')}
                  id="PerPerson"
                  onChange={this.onTypeChoice}
                >
                  Per Person
                </RadioButton>
                <RadioButton
                  name="tripBudgetType"
                  value={t('total_trip')}
                  checked={this.state.tripBudgetTypeValue === t('total_trip')}
                  id="TotalTrip"
                  onChange={this.onTypeChoice}
                >
                  {t('total_trip_value')}
                </RadioButton>
              </div>
            </div>
          </div>
          <div className="form-group">
            <h3 className="sub-header">{t('general_comments')}</h3>
            <h4 className="sub-header-small">{t('general_sub_comments')}</h4>
            <TextAreaInput
              value={this.state.comments}
              id="comments"
              onChange={this.onChangeComments}
              maxChars={1200}
              minChars={40}
              isGroup={false}
            />
          </div>
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('booking_steps'))

export default enhance(AddInfo)



// WEBPACK FOOTER //
// src/components/Guru/BookingSteps/Steps/AddInfo.jsx